'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondFromNow.js
// module id = 377
// module chunks = 1